"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sidebarMenuMinWidth = exports.sidebarMenuMaxWidth = exports.dropdownMaxHeight = void 0;
const dropdownMaxHeight = 300;
exports.dropdownMaxHeight = dropdownMaxHeight;
const sidebarMenuMinWidth = 240;
exports.sidebarMenuMinWidth = sidebarMenuMinWidth;
const sidebarMenuMaxWidth = 327;
exports.sidebarMenuMaxWidth = sidebarMenuMaxWidth;